import { Card, CardProps, Elevation, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';

interface ProductCardProps extends CardProps {
  altText: string;
  description: string;
  image: any;
  label: string;
  link: string;
}

export const ProductCard: React.VFC<ProductCardProps> = ({
  altText,
  description,
  image,
  label,
  link,
}) => {
  const labelWords = label.split(' ');

  const productName = labelWords.pop();
  const className = `product ${productName?.toLowerCase()}`;

  return (
    <a
      className="sd-drawer-publish-project__explorer-link__product-card"
      data-testid={TEST_IDS.publishProjectDrawer.openInExplorer.link}
      href={link}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Card elevation={Elevation.ONE} interactive role="button">
        <span className="product-card-icon">
          <Icon icon={IconNames.SHARE} />
        </span>
        <span className={className}>
          <img alt={altText} src={image} />
        </span>
        <p className="product-description">{description}</p>
      </Card>
    </a>
  );
};
